module.exports = __webpack_public_path__ + "static/media/MyTasksDropdown.f5819214.svg";